import React, { useMemo } from "react"
import { cx } from "class-variance-authority"
import IconRenderer from "../../ui/icon/icon-renderer"
import Link from "../link"
import { btnCva } from "../../ui/button"
import { promoCampaign } from "./constants"

export const ContentBar = ({ campaign }: { campaign: string }) => {
  const campaignData = useMemo(() => {
    if (!promoCampaign.content[campaign]) {
      return null
    }

    return promoCampaign.content[campaign]
  }, [campaign])

  if (!campaignData) {
    return <></>
  }

  const PromoSection = ({ className }: { className?: string }) => {
    return (
      <div
        className={cx(
          "xl:w-3/5 w-full flex justify-between xl:items-center items-start xl:rounded-[999px] xl:px-4 2xl:px-24 p-4 hello-bar",
          campaignData.variant === "teal" ? "bg-teal-10" : "bg-accent-9",
          className
        )}
      >
        <div className="flex xl:flex-row flex-col xl:gap-4 xl:items-center">
          <IconRenderer iconType="other" iconName={campaignData.logo} />
          <p className="lg:text-jar-4 xs:text-jar-2 md:text-jar-3 font-medium text-white">
            {campaignData.title}
          </p>
        </div>
        <Link
          external
          to={campaignData.link}
          target="_blank"
          className={btnCva({
            variant: "alternative",
            theme: "neutral",
            size: 2,
            className: `lg:text-jar-4 xs:text-jar-2 md:text-jar-3 ${
              campaignData.variant === "teal"
                ? "bg-neon-green-1"
                : "rounded-[28px] "
            }`,
          })}
        >
          {campaignData.CTAText}
        </Link>
      </div>
    )
  }

  return (
    <div
      className={cx(
        "w-full h-full flex xl:justify-center",
        campaignData.variant === "teal" ? "bg-teal-10" : "bg-accent-3"
      )}
    >
      <div className="w-full xl:hidden">
        <PromoSection />
      </div>
      <div className="relative w-4/5 xl:flex justify-center hidden">
        <div
          className={cx(
            "h-full w-full rounded-[999px] absolute top-0",
            campaignData.variant === "teal" ? "bg-teal-10" : "bg-accent-4"
          )}
        />
        <div
          className={cx(
            "h-full w-4/5 rounded-[999px] bg-accent-6 absolute top-0",
            campaignData.variant === "teal" ? "bg-teal-10" : "bg-accent-6"
          )}
        />
        <PromoSection className="z-[101]" />
      </div>
    </div>
  )
}
